import { render } from "./ImageInput.vue?vue&type=template&id=60c19d2f&scoped=true&ts=true"
import script from "./ImageInput.ts?vue&type=script&lang=ts"
export * from "./ImageInput.ts?vue&type=script&lang=ts"

import "./ImageInput.vue?vue&type=style&index=0&id=60c19d2f&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c19d2f"]])

export default __exports__